module.exports = __webpack_public_path__ + "img/organization-1-old.cbf21f4f.jpg";